import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './authprovider';
import { BrowserRouter } from 'react-router-dom';
import { NavigationProvider } from './NavigationProvider';
import { WebSocketProvider } from './WebSocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <WebSocketProvider>
      <NavigationProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </NavigationProvider>
    </WebSocketProvider>
  </BrowserRouter>
);

reportWebVitals();
